<template>
  <div id="app">
    <router-view :style="fullStyle" />
  </div>
</template>

<script>
import { isPC, openFullScreen, exitFullScreen } from '../static/util/pqtutil'
let ispc = true
export default {
  name: 'App',
  data() {
    return {
      fullStyle: {}
    }
  },
  beforeCreate() {
    ispc = isPC(navigator.userAgent)
  },
  beforeMount() {
    // if (!ispc) {

      const { clientHeight, clientWidth } = document.body

      const docEl = document.documentElement
      let fs = 20 * (clientWidth / 1920)
      if(fs > 20) {
        fs = 20
      } else if (fs < 10) {
        fs = 10
      }
      //限制最大字体可能出现「截图」相关功能字号与显示不一致的问题
      docEl.style.fontSize = `${fs}px`

      this.fullStyle = {
        height: clientHeight + 'px',
        width: clientWidth + 'px'
      }
      window.onresize = () => {
        const { clientHeight, clientWidth } = document.body
        this.fullStyle = {
          height: clientHeight + 'px',
          width: clientWidth + 'px'
        }

        let fs = 20*(clientWidth / 1920)
        if(fs > 20) {
          fs = 20
        } else if (fs < 10) {
          fs = 10
        }
        //限制最大字体可能出现「截图」相关功能字号与显示不一致的问题
        docEl.style.fontSize = `${fs}px`
      }
    // }
  }
}
</script>

<style>
body {
  margin: 0;
  width: 100vw;
  height: 100vh;
}
::-webkit-scrollbar {
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue